import * as React from 'react';

import { Link } from 'react-router-dom';

import Base from './Base';

/* @jsxImportSource @emotion/react */  import { css, jsx } from '@emotion/react'; /* eslint-disable-line */

const componentCss = css`


`;

export default React.forwardRef(({ selectedNav, index }, ref) => {

	return <div css={componentCss}>
		<Base ref={ref} index={index} selectedNav={selectedNav}>
			<div className="megamenu">
				<div className="megamenu-columns">
					<div className="primary-columns">
						<h2>Summary</h2>
						<div className="columns-2">
							<div className="primary-column">
								<h3>Dashboards</h3>
								<Link to="/r/zone-lock/today/rg/all/rz/all" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-cat" />
											</div>
										</div>
										<div>
											<h4>Zone Lock</h4>
											<p className="link-subtext">Dashboard</p>
										</div>
									</div>
								</Link>
								<Link to="/r/depot/today/s/all" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-cat" />
											</div>
										</div>
										<div>
											<h4>Depot</h4>
											<p className="link-subtext">Depot</p>
										</div>
									</div>
								</Link>
								<Link to="/r/hds-client" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-cat" />
											</div>
										</div>
										<div>
											<h4>HDS Client Summary</h4>
											<p className="link-subtext">Dashboard</p>
										</div>
									</div>
								</Link>
								<Link to="/r/client" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-cat" />
											</div>
										</div>
										<div>
											<h4>Client Summary</h4>
											<p className="link-subtext">Dashboard</p>
										</div>
									</div>
								</Link>
								<Link to="/r/customer-service" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-cat" />
											</div>
										</div>
										<div>
											<h4>Customer Service</h4>
											<p className="link-subtext">Dashboard</p>
										</div>
									</div>
								</Link>
								<Link to="/r/auspost" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-cat" />
											</div>
										</div>
										<div>
											<h4>Auspost</h4>
											<p className="link-subtext">Summary</p>
										</div>
									</div>
								</Link>
							</div>
							<div className="primary-column">
								<h3>Reports</h3>
								<Link to="/r/routing/comparison/depot/-/unrouted/week/this-week/none/yes/c/all/rg/all/rz/all/z/all/col/all" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-cat" />
											</div>
										</div>
										<div>
											<h4>Comparison Report</h4>
											<p className="link-subtext">Compare</p>
										</div>
									</div>
								</Link>
								<Link to="/r/admin" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-cat" />
											</div>
										</div>
										<div>
											<h4>Geocode Report</h4>
											<p className="link-subtext">View Geocoding Stats</p>
										</div>
									</div>
								</Link>
								<Link to="/r/sync-log" >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-cat" />
											</div>
										</div>
										<div>
											<h4>System Log</h4>
											<p className="link-subtext">Information on background tasks</p>
										</div>
									</div>
								</Link>
							</div>
						</div>
					</div>
					<div className="secondary-columns">

					</div>
				</div>
			</div>
		</Base>
	</div>

});
